import axios from 'axios';

export default axios.create({
    baseURL: 'https://mpdb2.parsigdatabase.com/',
    //baseURL: 'http://localhost:3166/',
    //baseURL: 'http://localhost/api',
    //baseURL: 'http://91.98.75.161:4443/mpdbwebapi/',
    //timeout: 20000,
    headers: {
        'Authorization':"Basic "+ btoa("reza:WE15214HsA522")
    }
    
});

// const client = axios.create({
//     baseURL: 'http://localhost:10000/v1/client',
//     timeout: 20000
//   })
  
//   let result = await client.get('/fetchMeSomething', {
//     onDownloadProgress: progressEvent => {
//       const total = parseFloat(progressEvent.currentTarget.responseHeaders['Content-Length'])
//       const current = progressEvent.currentTarget.response.length
  
//       let percentCompleted = Math.floor(current / total * 100)
//       console.log('completed: ', percentCompleted)
//     }
//   })
//   .then(res => {
//     console.log("All DONE: ", res.headers)
//     return res.data
//   })




// async function postData(url = '', data = {}) {
//     // Default options are marked with *
//     const response = await fetch(url, {
//       method: 'POST', // *GET, POST, PUT, DELETE, etc.
//       mode: 'cors', // no-cors, *cors, same-origin
//       cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
//       credentials: 'same-origin', // include, *same-origin, omit
//       headers: {
//         'Content-Type': 'application/json'
//         // 'Content-Type': 'application/x-www-form-urlencoded',
//       },
//       redirect: 'follow', // manual, *follow, error
//       referrerPolicy: 'no-referrer', // no-referrer, *client
//       body: JSON.stringify(data) // body data type must match "Content-Type" header
//     });
//     return await response.json(); // parses JSON response into native JavaScript objects
//   }

//   async function getData(url = '', data = {}) {
//     // Default options are marked with *
//     const response = await fetch(url, {
//       method: 'POST', // *GET, POST, PUT, DELETE, etc.
//       mode: 'cors', // no-cors, *cors, same-origin
//       cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
//       credentials: 'same-origin', // include, *same-origin, omit
//       headers: {
//         'Content-Type': 'application/json'
//         // 'Content-Type': 'application/x-www-form-urlencoded',
//       },
//       redirect: 'follow', // manual, *follow, error
//       referrerPolicy: 'no-referrer', // no-referrer, *client
//       body: JSON.stringify(data) // body data type must match "Content-Type" header
//     });
//     return await response.json(); // parses JSON response into native JavaScript objects
//   }